import React from 'react';
import PropTypes from 'prop-types';

import { bizminderColors } from '../../utils/globals';

const styles = {
  card: {
    backgroundColor: '#FFFFFF',
    border: `1px solid ${bizminderColors[0]}`,
    borderRadius: 2,
    width: '100%',
    margin: '20px 0',
  },
  header: {
    backgroundColor: bizminderColors[0],
    color: '#FFFFFF',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 15,
  },
  title: {
    color: 'inherit',
    margin: 0,
    fontSize: '1.2rem',
  },
};

const BizCard = (props) => (
  <div style={styles.card}>
    <div style={styles.header}>
      <h3 style={styles.title}>{props.title}</h3>
    </div>
    {props.children}
  </div>
);

BizCard.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

export default BizCard;



// WEBPACK FOOTER //
// ./src/components/UI/BizCard.jsx